import React, { useEffect, useState } from 'react';

import Cross from '../../assets/icons/cross.svg';
import ModalType from '../../models/ModalType';
import SectionType from '../../models/SectionType';
import BlogSection from './sections/blogSection';
import CareTeamSection from './sections/careTeamSection';
import FaqSection from './sections/faqSection';
import GetTestedSection from './sections/getTestedSection';
import HeroSection from './sections/heroSection';
import HeroV2Section from './sections/heroV2Section';
import HeroV3Section from './sections/heroV3Section';
import HowItWorksSection from './sections/howItWorksSection';
import InsurancesSection from './sections/insurancesSection';
import OurServiceSection from './sections/ourServiceSection';
import PressSection from './sections/pressSection';
import QualityCareSection from './sections/qualityCareSection';
import ReferSection from './sections/referSection';
import ReviewsSection from './sections/reviewsSection';
import SleepDisordersSection from './sections/sleepDisordersSection';

import { formatHomePageContent } from '../../hooks/staticQueries/useGetHomePageContent';
import { useModal } from '../../context/ModalContext';

import '../../pages/styles/homePage.scss';

export default function homePage({ pageContext: { content } }) {
  const formattedContent = formatHomePageContent(content);
  const { openModal } = useModal();

  const [displayHeadbandPopup, setDisplayHeadbandPopup] = useState(false);

  // Check from where the user is coming from
  useEffect(() => {
    const from = new URLSearchParams(window.location.search).get('from');
    if (!from) return;

    if (from === 'dreem') {
      setDisplayHeadbandPopup(true);
    }

    if (window.posthog) window.posthog.capture('user_from', { source: from });
  }, []);

  function handleHeadbandPopupClick() {
    if (window.posthog) window.posthog.capture('cta_headband_popup');

    openModal(ModalType.HEADBAND);
  }

  return (
    <>
      {displayHeadbandPopup && (
        <div className="headband-popup">
          <p className="hand">👋</p>
          <button
            type="button"
            onClick={() => handleHeadbandPopupClick()}
          >
            Looking for the Dreem headband?
          </button>
          <Cross
            width="14px"
            height="14px"
            onClick={() => setDisplayHeadbandPopup(false)}
          />
        </div>
      )}

      { formattedContent.sections.map((section, i) => (
        <div style={{ zIndex: formattedContent.sections.length - i, position: 'relative' }} key={section.toString()}>
          { section === SectionType.HERO && (
            <HeroSection
              title={formattedContent.home.title}
              subtitle={formattedContent.home.subtitle}
              button={formattedContent.home.button}
              contentSize={formattedContent.home.contentSize}
            />
          )}

          { section === SectionType.HERO_V2 && (
            <HeroV2Section
              title={formattedContent.home.title}
              subtitle={formattedContent.home.subtitle}
              button={formattedContent.home.button}
              backgroundUrl={formattedContent.home.backgroundUrl}
            />
          )}

          { section === SectionType.HERO_V3 && (
            <HeroV3Section
              title={formattedContent.home.title}
              subtitle={formattedContent.home.subtitle}
              eligibilityTitle={formattedContent.home.eligibilityTitle}
              button={formattedContent.home.button}
              backgroundUrl={formattedContent.home.backgroundUrl}
            />
          )}

          { section === SectionType.INSURANCES && (
            <InsurancesSection
              pretitle={formattedContent.insurances.pretitle}
              title={formattedContent.insurances.title}
              subtitle={formattedContent.insurances.subtitle}
            />
          )}

          { section === SectionType.OUR_SERVICE && (
            <OurServiceSection
              pretitle={formattedContent.service.pretitle}
              title={formattedContent.service.title}
              subtitle={formattedContent.service.subtitle}
            />
          )}

          { section === SectionType.QUALITY_CARE && <QualityCareSection />}

          { section === SectionType.HOW_IT_WORKS && (
            <HowItWorksSection
              pretitle={formattedContent.hiw.pretitle}
              title={formattedContent.hiw.title}
              subtitle={formattedContent.hiw.subtitle}
              steps={formattedContent.hiw.steps}
            />
          )}

          {section === SectionType.SLEEP_DISORDERS && <SleepDisordersSection />}

          {section === SectionType.GET_TESTED && <GetTestedSection />}

          { section === SectionType.CARE_TEAM && (
            <CareTeamSection
              pretitle={formattedContent.aboutUs.pretitle}
              title={formattedContent.aboutUs.title}
              subtitle={formattedContent.aboutUs.subtitle}
            />
          )}

          { section === SectionType.REVIEWS && (
            <ReviewsSection
              pretitle={formattedContent.reviews.pretitle}
              title={formattedContent.reviews.title}
              subtitle={formattedContent.reviews.subtitle}
            />
          )}

          { section === SectionType.PRESS && (
            <PressSection title={formattedContent.press.title} />
          )}

          { section === SectionType.BLOG && <BlogSection />}

          { section === SectionType.FAQ && <FaqSection questions={formattedContent.faqQuestions} />}

          { section === SectionType.REFER && <ReferSection />}
        </div>
      ))}
    </>
  );
}
